export const EstadoFirmaColaborador = Object.freeze({
    NO_APLICA: "NO_APLICA",
    PENDIENTE: "PENDIENTE",
    FIRMADO: "FIRMADO"
});
